module.exports = __webpack_public_path__ + "img/80.cf234f2e.svg";